// removed by extract-text-webpack-plugin
module.exports = {"Public":"_13MTRthvFoI278THY4dveF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/public/public.css
// module id = 382
// module chunks = 0